// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://app-test.ottremit.com',
  mobileUrl: 'https://crossborder-remittance-test.ott.ca',
  INTERAC_URL: 'https://xboard.ott.ca/interac/payment?',
  slackMsg: 'https://hooks.slack.com/services/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',
  sentryUrl: 'https://b6b62c18385d4b2e82f1c9a5212c3c2a@o1265632.ingest.sentry.io/6449727',
  version: '1.0.4.1',
  download: {
    ios: 'https://apps.apple.com/ca/app/id1551385724',
    android: 'https://play.google.com/store/apps/details?id=com.ott.crossborder'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDuONHOaCVbrr8lipHb01d5hWhjJ7LQPGI',
    authDomain: 'ott-crossborder-remittance.firebaseapp.com',
    projectId: 'ott-crossborder-remittance',
    storageBucket: 'ott-crossborder-remittance.appspot.com',
    messagingSenderId: '12466819276',
    appId: '1:12466819276:web:f44cb995c474a66c93b269',
    measurementId: 'G-ZBEWQK0Z7S'
  },
  appsflyer: {
    appID: '1551385724',
    devKey: 'xnUukdPoV5v7qhtuDiDrDD',
    isDebug: true,
    waitForATTUserAuthorization: 10,
    registerOnDeepLink: true,
    registerConversionListener: true,
    timeToWaitForATTUserAuthorization: 120
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
